module.exports = __webpack_public_path__ + "media/images/company/cp14-3c7469ab5e1a89d1ffb4efa2e0e75d7a.png";